import { useIntl } from 'react-intl';
import { IconDatabaseOff } from '@rossum/ui/icons/tabler';
import {
  CircularProgress,
  Stack,
  SvgIcon,
  Typography,
  useTheme,
} from '@rossum/ui/material';
import { linebreak, routerLink } from '../../../lib/formaterValues';
import { datasetsPath } from '../routes';

export const NotFound = ({
  datasetUploadInProgress,
}: {
  datasetUploadInProgress: boolean;
}) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <Stack
      p={3}
      alignItems="center"
      justifyContent="center"
      gap={3}
      m="auto"
      textAlign="center"
    >
      {datasetUploadInProgress ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          spacing={3}
          direction="column"
        >
          <CircularProgress />
          <Typography variant="h5">
            {intl.formatMessage({
              id: 'features.datasets.importInProgress.title',
            })}
          </Typography>
        </Stack>
      ) : (
        <>
          <SvgIcon
            fontSize="xLarge"
            sx={{
              color: theme.palette.action.disabled,
              width: 48,
              height: 48,
            }}
          >
            <IconDatabaseOff strokeWidth={1} />
          </SvgIcon>
          <Stack alignItems="center" justifyContent="center" gap={2}>
            <Typography variant="h5">
              {intl.formatMessage({ id: 'features.datasets.notFound.title' })}
            </Typography>
            <Typography>
              {intl.formatMessage(
                { id: 'features.datasets.notFound.description' },
                {
                  link: routerLink({
                    route: datasetsPath(),
                    color: theme.palette.text.secondary,
                  }),
                  linebreak,
                }
              )}
            </Typography>
          </Stack>
        </>
      )}
    </Stack>
  );
};
